module.exports = __webpack_public_path__ + "static/media/FattyPay_DuitNow_app.8704577a.svg";